<!-- eslint-disable max-len -->
<template>
  <div class="download-content">
    <h3 class="account-sub-title d-none d-md-block">
      <i class="sicon-note align-middle mr-3"></i>{{ translations.rmaForm }}
    </h3>
    <div class="download-table-container">
      <div class="rma-tabs">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active pt-md-2 pt-5" id="new-rma-b2b" data-toggle="tab" href="#new-rma" role="tab"
              aria-controls="new-rma" aria-selected="true">{{ translations.newRequest }}</a>
          </li>

          <li class="nav-item" v-for="item in statuses" :key="item.id" @click="getComplaints(item.id)">
            <a class="nav-link pt-md-2 pt-5" :href="`#rma-${item.id}`" data-toggle="tab" role="tab" :aria-controls="`#rma-${item.id}`"
              aria-selected="false">
              {{ item.title }}
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="new-rma" role="tabpanel" aria-labelledby="new-rma">
            <form @submit.prevent.stop="handleSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="contactPerson">
                      {{ translations.contactPerson }}
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="" id="contactPerson" name="contactPerson"
                      required="" v-model="contactPerson" />
                  </div>
                  <div class="form-group">
                    <label for="productName">
                      {{ translations.productName }}
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="" id="productName" name="productName" required=""
                      v-model="articleTitle" />
                  </div>
                  <div class="form-group">
                    <label for="productCode">
                      {{ translations.productCode }}
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="" id="productCode" name="productCode" required=""
                      v-model="articleCode" />
                  </div>
                  <div class="form-group">
                    <label for="productBrand">
                      {{ translations.brand }}
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="" id="productBrand" name="productBrand"
                      required="" v-model="articleBrand" />
                  </div>

                  <div class="form-group">
                    <label for="productSerial">
                      {{ translations.serialNumber }}
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="" id="productSerial" name="productSerial"
                      required="" v-model="articleSerialNumber" />
                  </div>

                  <div class="form-group">
                    <label for="formFileMultiple" class="form-label">{{ translations.uploadAttachment }}</label>
                    <input class="form-control" type="file" ref="image" id="formFileMultiple" accept="image/*"
                      @change="handlePhotoUpload" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="rmaDescription">{{ translations.description }}
                      <span class="required">*</span>
                    </label>
                    <textarea id="rmaDescription" class="form-control" name="rmaDescrip" rows="12"
                      style="line-height: 1.54" v-model="description" required></textarea>
                  </div>

                  <hr />

                  <div class="align-items-baseline d-flex radio-wrapper">
                    <label>
                      {{ translations.warranty }}
                      <span class="required">*</span>
                    </label>
                    <div class="form-group">
                      <div class="custom-control custom-radio d-flex">
                        <input type="radio" class="custom-control-input" name="radio" value="1" v-model="hasWarranty"
                          required />
                        <label class="custom-control-label-radio">{{ translations.yes }}</label>
                      </div>
                      <!-- End .custom-checkbox -->
                    </div>
                    <!-- End .form-group -->
                    <div class="form-group">
                      <div class="custom-control custom-radio d-flex">
                        <input type="radio" class="custom-control-input" name="radio" value="2" v-model="hasWarranty" />
                        <label class="custom-control-label-radio">{{ translations.no }}</label>
                      </div>
                      <!-- End .custom-checkbox -->
                    </div>
                    <!-- End .form-group -->
                    <div class="form-group">
                      <div class="custom-control custom-radio d-flex">
                        <input type="radio" class="custom-control-input" name="radio" checked value="3"
                          v-model="hasWarranty" />
                        <label class="custom-control-label-radio">{{ translations.indeterminate }}</label>
                      </div>
                      <!-- End .custom-checkbox -->
                    </div>
                    <!-- End .form-group -->
                  </div>
                  <div class="form-group">
                    <label for="accountNumber">{{ translations.accountNumber }}</label>
                    <input type="text" class="form-control" placeholder="" id="accountNumber" name="accountNumber"
                      v-model="billNumber" />
                  </div>
                </div>
              </div>

              <hr />

              <button type="submit" class="btn btn-primary">{{ translations.send }}</button>
              <router-link :to="{ name: 'Home' }" exact class="btn btn-outline-secondary ml-2">
                {{ translations.continueShopping }}
              </router-link>
            </form>
          </div>
          <!-- End .tab-pane -->

          <div class="tab-pane fade" :id="`rma-${item.id}`" role="tabpanel"
            v-for="item in statuses" :key="item.id">
            <div class="messages-accordion" v-if="complaints.length">
              <div
                class="card card-accordion accordion-boxed"
                v-for="(complaint, index) in complaints"
                :key="complaint.id"
              >
                <a class="card-header old-message accordion-button" href="#" data-toggle="collapse" :data-target="`#collapse-${complaint.id}`"
                  aria-expanded="false" :aria-controls="`#collapse-${complaint.id}`">
                  <table class="table-accordion">
                    <thead>
                      <tr>
                        <th width="10%">{{ translations.ord.toUpperCase() }}</th>
                        <th width="15%">{{ translations.registrationCode }}</th>
                        <th width="15%">{{ translations.created }}</th>
                        <th width="20%">{{ translations.contactPerson }}</th>
                        <th width="30%">{{ translations.description }}</th>
                        <th width="30%">{{ translations.status }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ index + 1 }}</td>
                        <td>#{{ complaint.id }}</td>
                        <td>{{ formatDate(complaint.createdDate, 'dd.MM.yyyy') }}</td>
                        <td>{{ complaint.contactPerson }}</td>
                        <td>{{ complaint.description }}</td>
                        <td>{{ statuses.find(({ id }) => id == complaint.problemStatus).title }}</td>
                      </tr>
                    </tbody>
                  </table>
                </a>
                <div class="accordion-collapse">
                  <div :id="`collapse-${complaint.id}`" class="acordion-body collapse-padding collapse">
                    <table class="table-in-accordion">
                      <thead>
                        <tr>
                          <th>{{ translations.productName }}</th>
                          <th>{{ translations.productCode }}</th>
                          <th>{{ translations.warranty }}</th>
                          <th>{{ translations.accountNumber }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ complaint.articleTitle }}</td>
                          <td>{{ complaint.articleCode }}</td>
                          <td>{{ complaint.hasWarranty ? translations.yes : translations.no }}</td>
                          <td>{{ complaint.billNumber || 'N/A' }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="mt-2 alert alert-info">
                      {{ translations.comment }}:

                      {{ complaint.comment || 'N/A' }}
                    </div>

                    <hr />
                  </div>
                </div>
              </div>
            </div>
            <div id="accordion4" v-else>
              <div class="alert alert-info">
                {{ translations.noRecords }}
              </div>
            </div>
          </div>
          <!-- End .tab-pane -->
        </div>
        <!-- End .tab-content -->
      </div>

      <!-- End .tab-pane -->
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { translations } from '@/mixins';
import api from '@/services/api';
import helpers from '@/services/helpers';

// Na cekanju: 1, zavrseno: 4
// dodati na responseu sifra prijave i datum kreiranja

export default {
  name: 'RMA',
  mixins: [translations],
  data() {
    return {
      contactPerson: '',
      billNumber: '',
      hasWarranty: '',
      description: '',
      articleTitle: '',
      articleCode: '',
      articleSerialNumber: '',
      image: {
        file: '',
        fileName: '',
      },
      articleBrand: '',
    };
  },
  computed: {
    statuses() {
      return helpers.RMAProblemStatusCodesArray;
    },
    complaints() {
      return this.$store.getters.getComplaints;
    },
  },
  methods: {
    handleSubmit() {
      // eslint-disable-next-line no-nested-ternary
      this.hasWarranty = this.hasWarranty === '1' ? true : (this.hasWarranty === '2' ? false : null);

      const {
        contactPerson,
        billNumber,
        hasWarranty,
        description,
        articleTitle,
        articleCode,
        articleSerialNumber,
        image,
        articleBrand,
      } = this;

      api.createComplaint({
        contactPerson,
        billNumber,
        hasWarranty,
        description,
        articleTitle,
        articleCode,
        articleSerialNumber,
        image,
        articleBrand,
      }).then((response) => {
        this.$toast.info(response.data.info);
        this.contactPerson = '';
        this.billNumber = '';
        this.hasWarranty = '';
        this.description = '';
        this.articleTitle = '';
        this.articleCode = '';
        this.articleSerialNumber = '';
        this.image = {
          file: '',
          fileName: '',
        };
        this.articleBrand = '';
        this.$refs.image.value = null;
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    formatDate(date, dateFormat) {
      return format(new Date(date), dateFormat);
    },
    handlePhotoUpload() {
      const file = this.$refs.image.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        // eslint-disable-next-line prefer-destructuring
        this.image.file = e.target.result.split(',')[1];
        this.image.fileName = file.name;
      };
    },
    getComplaints(id) {
      this.$store.dispatch('getComplaints', {
        pageSize: 20,
        page: 1,
        sortBy: 'createdDate',
        isSortAscending: true,
        retrieveAll: true,
        quickSearch: '',
        problemStatus: id,
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>
